export const ROOT = '/';
export const DASHBOARD_URL = '/dashboard';
export const PROFILE_BASE_URL = 'profile';

//Auth
export const ROUTE_AUTH_BASE = '';
export const ROUTE_AUTH_FULL_PATH = `/${ROUTE_AUTH_BASE}`;
export const ROUTE_SIGN_IN = '';
export const ROUTE_REGISTER = 'register';
export const ROUTE_FORGET_PASSWORD = 'forgot-password';
export const ROUTE_FORGET_PASSWORD_SUCCESS = 'success';
export const ROUTE_AUTH_URL = `${ROUTE_AUTH_BASE}/*`;

//Store
export const ROUTE_STORE_BASE_URL = 'store';
export const ROUTE_STORE_FULL_URL = `${DASHBOARD_URL}/${ROUTE_STORE_BASE_URL}`;

//Order
export const ROUTE_ORDER_BASE_URL = 'order';
export const ROUTE_ORDER_FULL_URL = `${DASHBOARD_URL}/${ROUTE_ORDER_BASE_URL}`;

//Order Result
export const ROUTE_ORDER_RESULT_BASE_URL = 'order-result';

//package
export const ROUTE_PACKAGE_BASE_URL = 'packages';
export const ROUTE_PACKAGE_FULL_URL = `${DASHBOARD_URL}/${ROUTE_PACKAGE_BASE_URL}`;

//eSims
export const ROUTE_MY_ESIMS_BASE_URL = 'eSims';
export const ROUTE_MY_ESIMS_FULL_URL = `${DASHBOARD_URL}/${ROUTE_MY_ESIMS_BASE_URL}`;

//Profile
export const ROUTE_PROFILE_BASE_URL = 'profile';
export const ROUTE_PROFILE_FULL_URL = `${DASHBOARD_URL}/${ROUTE_PROFILE_BASE_URL}`;

//Billing
export const ROUTE_BILLING_BASE_URL = 'billing';
export const ROUTE_BILLING_FULL_URL = `${DASHBOARD_URL}/${ROUTE_BILLING_BASE_URL}`;

//Invite Friends
export const ROUTE_INVITE_FRIENDS_BASE_URL = 'invite-friends';
export const ROUTE_INVITE_FRIENDS_FULL_URL = `${DASHBOARD_URL}/${ROUTE_INVITE_FRIENDS_BASE_URL}`;

//Help and Support
export const ROUTE_HELP_AND_SUPPORT_BASE_URL = 'helpAndSupport';
export const ROUTE_HELP_AND_SUPPORT_FULL_URL = `${DASHBOARD_URL}/${ROUTE_HELP_AND_SUPPORT_BASE_URL}`;

//FAQ
export const ROUTE_FAQ_BASE_URL = 'faq';
export const ROUTE_FAQ_FULL_URL = `${DASHBOARD_URL}/${ROUTE_FAQ_BASE_URL}`;

//Affiliate
export const ROUTE_AFFILIATE_BASE_URL = 'affiliate';
export const ROUTE_AFFILIATE_FULL_URL = `${DASHBOARD_URL}/${ROUTE_AFFILIATE_BASE_URL}`;
